import React, { useEffect, useState } from 'react';

import { deployDetailParams } from 'api';
import { useApp } from 'contexts';
import { useQuery } from 'hooks';

type DeployContext = {
	deploy: any;
	setDeploy: any;
	options: any;
	setOptions: any;
	isOwner: boolean;
	rootApi: string;
	rootLink: string;
	loading: boolean;
	onUpdate: any;
	onRefresh: any;
};

export const DeployContext = React.createContext<DeployContext>(null);

const DeployProvider = ({ ssr, workspace, router, session, store, toast, children }) => {
	const [deploy, setDeploy] = useState(ssr.deploy?.data || {});
	const [options, setOptions] = useState({
		sidebar: true,
		browser: {
			actions: false,
			footer: false,
		},
	});
	const [loaded, setLoaded] = useState(false);
	const app = useApp();

	// Computed
	const rootApi = deploy.apiPath;
	const rootLink = deploy.appPath;
	const isOwner = workspace.workspace?.id === deploy.workspaceId;

	// Hooks
	useEffect(() => {
		setLoaded(true);
		return () => onClear();
	}, []);

	useEffect(() => {
		setDeploy(ssr.deploy?.data || {});
	}, [ssr.deploy, router.asPath]);

	useEffect(() => {
		setOptions({ ...options, sidebar: app.size.md });
	}, [app.size.md]);

	useEffect(() => {
		if (deploy.id !== ssr.deploy?.data.id) setOptions({ ...options, settings: false, view: 'about' });
	}, [deploy.id]);

	// Actions
	const [fetchData, loading, error] = useQuery(async () => {
		const response = await store.queryRecord({
			url: `${workspace.rootApi}/deploys/${deploy.uuid}`,
			params: deployDetailParams,
		});
		setDeploy({ ...deploy, ...response.data });
	});

	// Methods
	const onUpdate = data => setDeploy({ ...deploy, ...data });
	const onRefresh = () => fetchData();
	const onClear = () => setDeploy({});

	// Render
	return (
		<DeployContext.Provider
			value={{
				deploy,
				setDeploy,
				options,
				setOptions,
				isOwner,
				rootApi,
				rootLink,
				loading,
				onUpdate,
				onRefresh,
			}}>
			{children}
		</DeployContext.Provider>
	);
};

const useDeploy = () => {
	return React.useContext(DeployContext);
};

export { DeployProvider, useDeploy };
